<template>
  <div class="column content-box settings--content">
    <label class="step-title">{{
      $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.RESOLUTION_RULES.TITLE')
    }}</label>
    <div v-for="(item, index) in rules" :key="index" class="label-entry">
      <accordion-item
        :title="itemTitle(item)"
        :is-open="openAccordions[index]"
        @click="toggleAccordion(index)"
      >
        <label>
          {{
            $t(
              'INTEGRATION_SETTINGS.ASSISTENT.FORM.RESOLUTION_RULES.LABEL_RULE'
            )
          }}
          <textarea
            v-model.trim="rules[index]"
            class="textlong"
            :placeholder="
              $t(
                'INTEGRATION_SETTINGS.ASSISTENT.FORM.RESOLUTION_RULES.PLACEHOLDER_RULE'
              )
            "
          />
        </label>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          size="small"
          type="button"
          @click="removeItem(index)"
        >
          {{
            $t(
              'INTEGRATION_SETTINGS.ASSISTENT.FORM.RESOLUTION_RULES.BUTTON_REMOVE_TEXT'
            )
          }}
        </woot-button>
      </accordion-item>
    </div>
    <woot-button
      type="button"
      class="button--add-domain"
      icon="add"
      color-scheme="success"
      variant="smooth"
      size="small"
      @click="addItem"
    >
      <span>{{
        $t(
          'INTEGRATION_SETTINGS.ASSISTENT.FORM.RESOLUTION_RULES.BUTTON_ADD_TEXT'
        )
      }}</span>
    </woot-button>

    <div class="tab-footer">
      <woot-submit-button
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import assistentTabMixin from '../../mixins/assistentTabMixin';
import AccordionItem from '../../../profile/components/AccordionItem.vue';

export default {
  components: { AccordionItem },
  mixins: [assistentTabMixin],
  data() {
    const rules = this.assistent.resolution_rules || [];
    return {
      rules: [...rules],
      openAccordions: rules.map(() => false),
    };
  },
  methods: {
    itemTitle(item) {
      return (
        item ||
        this.$t(
          'INTEGRATION_SETTINGS.ASSISTENT.FORM.RESOLUTION_RULES.NEW_ITEM_TITLE'
        )
      );
    },
    toggleAccordion(index) {
      this.$set(this.openAccordions, index, !this.openAccordions[index]);
    },
    addItem() {
      this.rules.push('');
      this.openAccordions = this.openAccordions.map(() => false);
      this.openAccordions.push(true);
    },
    removeItem(index) {
      this.rules.splice(index, 1);
      this.openAccordions.splice(index, 1);
    },
    async onSubmit() {
      const validRules = this.rules.filter(item => item && item.trim());

      await this.saveAssistent({
        resolution_rules: validRules.map(item => item.trim()),
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
